import type { FieldPack } from "../engine/types";
import { translation } from "./translation";
import { law } from "./law";
import { summarize } from "./summarize";
import { letter } from "./letter";
import { explain } from "./explain";

/**
 * The registry. This is the ONLY file that changes when a field is added or removed.
 *
 * If you ever need to touch src/engine/ to add a field, the abstraction has failed.
 * Fix the abstraction — do not special-case the field.
 */
export const FIELDS: FieldPack[] = [translation, law, summarize, letter, explain];

export const FIELD_BY_ID: Record<string, FieldPack> = Object.fromEntries(
  FIELDS.map((f) => [f.id, f]),
);

export function getField(id: string): FieldPack | undefined {
  return FIELD_BY_ID[id];
}

export function visibleFields(): FieldPack[] {
  return FIELDS.filter((f) => !f.hidden);
}
